import { every, find, includes, map } from "lodash";
import useSWR from "swr";
import { Setting, SettingProduct } from "../models";
import { ModuleId, PackageId, ProductId } from "../types";
import fetcher from "./fetcher";

export const useSettings = (props: {
    companyId?: string;
    locationId?: string;
}) => {
    const { companyId, locationId } = props;

    const getAPI = () => {
        if (!companyId) {
            return null;
        }
        if (!locationId) {
            return `/api/permission-management/v1/companies/${companyId}`;
        }
        return `/api/permission-management/v1/companies/${companyId}/locations/${locationId}`;
    };
    const { data, error, isLoading } = useSWR(getAPI(), fetcher, {
        fallbackData: [],
    });

    // check every combination of product id + module id
    const hasProductModules = (products: SettingProduct[]): boolean => {
        return every(products, (productToCheck) => {
            const settingsProduct = find(data?.products, {
                id: productToCheck?.id,
            });
            if (settingsProduct) {
                const moduleIdsToCheck = map(productToCheck.modules, "id");
                const settingsModuleIds = map(settingsProduct.modules, "id");
                return every(moduleIdsToCheck, (id) =>
                    includes(settingsModuleIds, id)
                );
            }
            return false;
        });
    };

    const getModulePackages = (
        productId: ProductId,
        moduleId: ModuleId
    ): PackageId[] => {
        const settingsProduct = find(data?.products, { id: productId });
        return find(settingsProduct?.modules, { id: moduleId })?.packages ?? [];
    };

    return {
        settings: data as Setting,
        isLoadingSettings: isLoading,
        isError: error,
        hasProductModules,
        getModulePackages,
    };
};
